<template lang="pug">
y-dialog(v-if="showDialog" v-model="showDialog" max-width=568 :fullscreen="$vuetify.breakpoint.xsOnly" persistent fluid scrollable content-class="round-2xl")
  v-card
    v-card-title.px-4
      v-spacer
      .text-xl.font-bold.ml-10 Your CSV import is in process
      v-spacer
      v-btn(icon @click="done")
        v-icon mdi-close
    v-divider
    v-card-text.pa-8.primary--text
      v-img.mx-auto(:src="require('@/assets/images/upload_processing.gif')" width=88 contain)
      .font-medium.text-lg.mt-4 {{ text }}
    v-divider
    v-card-actions.px-6.py-4
      v-spacer
      v-btn.button-md(@click="done" color="info" depressed) {{ $t('done') }}
</template>

<script>
export default {
  props: {
    open: {
      type: Boolean,
      default: false
    },
    text: {
      type: String,
      default: null
    }
  },
  computed: {
    showDialog: {
      get () {
        return this.open
      },
      set (newValue) {
        this.$emit('update:open', newValue)
      }
    }
  },
  methods: {
    done () {
      this.$emit('done')
    }
  }
}
</script>
